import getActiveEntityRange from "editor/utils/getActiveEntityRange";
import getActiveBlockKey from "editor/utils/getActiveBlockKey";

export default function getActiveEntityText(editorState) {
  const entityRange = getActiveEntityRange(editorState);
  const activeBlock = editorState
    .getCurrentContent()
    .getBlockForKey(getActiveBlockKey(editorState));
  const blockText = activeBlock.getText();
  return blockText.slice(
    entityRange.getStartOffset(),
    entityRange.getEndOffset()
  );
}
